import { useState, useEffect } from "react";
import { get_kofi_inventory_cache } from "../../services/totoservice";
import { KofiShopGrid } from "tootles-kofi";
import { LoadingViewPlacholder, ErrorViewPlaceholder } from '../Template'
import 'tootles-kofi/dist/tootles-kofi.css'
import './shop.css'

const Shop = () => {

    const [inventory, setInventory] = useState([])
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleApiSuccess = (inventory_data) => {
        console.log('handleApiSuccess called with inventory_data =' + JSON.stringify(inventory_data))
        setInventory(inventory_data)
        setLoading(false);
    }

    const handleApiError = (err) => {
        console.log('handleApiError called with err =' + err)
        setError(err);
        setLoading(false);
    }

    async function fetchInventory() {
        const items = await get_kofi_inventory_cache(handleApiSuccess, handleApiError)
    }

    useEffect(() => {
        fetchInventory()
    }, []);


    if (loading) return <LoadingViewPlacholder title={"Loading shop from Ko-fi"} />;
    else if (error) return <ErrorViewPlaceholder title="Error getting shop data from Ko-fi" details="Please try again later" />;
    return (<main className="kofi-background main-layout kofi-background">
        <h1>Shop</h1>
        <KofiShopGrid inventory={inventory} />
    </main>)
}

export default Shop;